import React from "react";
import "./css/profile.css";
const Profile = () => {
  return (
    <div>
      <div className="navraextra"></div>
      <div className="profilemain">
        <div className="profileleft">
          <h1 className="profilename">Hi There</h1>
          <h1 className="profilename">I'm Bharat Rozodkar</h1>
          <h2 className="profilerole">A Full Stack Web Developer</h2>
          <a
            href="https://drive.google.com/drive/u/0/folders/1GvWYFVoAUcHb3-C9Yapf_5g4ctydtS6t"
            target="_blank"
            rel="noreferrer"
          >
            <button className="resumebtn">Resume</button>
          </a>
        </div>
        <div>
          <img className="bharatimg" src="./myfoto.png" alt="" />
        </div>
      </div>
    </div>
  );
};

export default Profile;
